// SPDX-License-Identifier: AGPL-3.0-or-later

import {ConfirmModal} from '@app/features/app/components/dialogs/ConfirmModal';
import {Plural, Trans, useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';

interface SlowmodeRateLimitedModalProps {
	retryAfter: number;
}
export const SlowmodeRateLimitedModal = observer(({retryAfter}: SlowmodeRateLimitedModalProps) => {
	const {t} = useLingui();
	const renderTime = (seconds: number): React.ReactNode => {
		if (seconds < 60) {
			return <Plural value={seconds} one="# second" other="# seconds" />;
		}
		const minutes = Math.floor(seconds / 60);
		const remainingSeconds = seconds % 60;
		if (remainingSeconds === 0) {
			return <Plural value={minutes} one="# minute" other="# minutes" />;
		}
		return (
			<Trans>
				<Plural value={minutes} one="# minute" other="# minutes" /> and{' '}
				<Plural value={remainingSeconds} one="# second" other="# seconds" />
			</Trans>
		);
	};
	return (
		<ConfirmModal
			title={t`Slowmode Active`}
			description={
				<Trans>
					This channel has slowmode enabled. You need to wait {renderTime(retryAfter)} before sending another message.
				</Trans>
			}
			primaryText={t`Okay`}
			onPrimary={() => {}}
			secondaryText={false}
			hideCloseButton
		/>
	);
});
